import { SvgIcon, SvgIconProps } from '@mui/material'

export function EditCalendar(props: SvgIconProps) {
  return (
    <SvgIcon role="img" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.167 6.334a.5.5 0 0 1 .5-.5h12.666a.5.5 0 0 1 .5.5v7c0 .644-.522 1.167-1.166 1.167H2.333a1.167 1.167 0 0 1-1.166-1.167v-7Zm1 .5v6.5c0 .092.074.167.166.167h11.334a.167.167 0 0 0 .166-.167v-6.5H2.167Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M2.333 2.834a.167.167 0 0 0-.166.167v2.833h11.666V3.001a.167.167 0 0 0-.166-.167H2.333Zm-1.166.167c0-.645.522-1.167 1.166-1.167h11.334c.644 0 1.166.522 1.166 1.167v3.333a.5.5 0 0 1-.5.5H1.667a.5.5 0 0 1-.5-.5V3.001Z"
        clipRule="evenodd"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M5.333.834a.5.5 0 0 1 .5.5v2.667a.5.5 0 0 1-1 0V1.334a.5.5 0 0 1 .5-.5ZM10.667.834a.5.5 0 0 1 .5.5v2.667a.5.5 0 1 1-1 0V1.334a.5.5 0 0 1 .5-.5ZM8.833 11.334a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5ZM4.167 11.334a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5ZM8.833 8.666a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5ZM4.167 8.666a.5.5 0 0 1 .5-.5h2a.5.5 0 1 1 0 1h-2a.5.5 0 0 1-.5-.5Z"
        clipRule="evenodd"
      />
    </SvgIcon>
  )
}

export default EditCalendar
